/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sync_Changes_Success_ToastInputs */

const en_sync_changes_success_toast = /** @type {(inputs: Sync_Changes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes synced successfully.`)
};

const fr_sync_changes_success_toast = /** @type {(inputs: Sync_Changes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications synchronisees avec succes.`)
};

const de_sync_changes_success_toast = /** @type {(inputs: Sync_Changes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen erfolgreich synchronisiert.`)
};

const it_sync_changes_success_toast = /** @type {(inputs: Sync_Changes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche sincronizzate correttamente.`)
};

const ru_sync_changes_success_toast = /** @type {(inputs: Sync_Changes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изменения успешно синхронизированы.`)
};

const es_sync_changes_success_toast = /** @type {(inputs: Sync_Changes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los cambios se sincronizaron correctamente.`)
};

const zh_cn2_sync_changes_success_toast = /** @type {(inputs: Sync_Changes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更改已成功同步。`)
};

const ja_sync_changes_success_toast = /** @type {(inputs: Sync_Changes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`変更が正常に同期されました。`)
};

const hi_sync_changes_success_toast = /** @type {(inputs: Sync_Changes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिवर्तन सफलतापूर्वक सिंक हो गए।`)
};

const pt_pt2_sync_changes_success_toast = /** @type {(inputs: Sync_Changes_Success_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações sincronizadas com sucesso.`)
};

/**
* | output |
* | --- |
* | "Changes synced successfully." |
*
* @param {Sync_Changes_Success_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const sync_changes_success_toast = /** @type {((inputs?: Sync_Changes_Success_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Changes_Success_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_sync_changes_success_toast(inputs)
	if (locale === "de") return de_sync_changes_success_toast(inputs)
	if (locale === "it") return it_sync_changes_success_toast(inputs)
	if (locale === "ru") return ru_sync_changes_success_toast(inputs)
	if (locale === "es") return es_sync_changes_success_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_sync_changes_success_toast(inputs)
	if (locale === "ja") return ja_sync_changes_success_toast(inputs)
	if (locale === "hi") return hi_sync_changes_success_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_sync_changes_success_toast(inputs)
	return en_sync_changes_success_toast(inputs)
});